<script>
  import { onMount, createEventDispatcher } from 'svelte';


  export let items = [];

  let components = {};
  let dispatch = createEventDispatcher();

  const open_tab = (e, id) => {
    let i, tabcontents, tablinks, item, button;

    tabcontents = document.getElementsByClassName("tab-content");
    Array.from(tabcontents)
        .map(tc => tc.classList.add("hidden"));

    tablinks = document.getElementsByClassName("tab-link");
    Array.from(tablinks)
        .map(tl => tl.classList.remove("active"));

    document.getElementById(id)
        .classList
        .remove("hidden");
    button = e ? e.target : tablinks[0];
    button.classList.add("active");

    if (e) {
      dispatch('tabactivated', {id: id, item: item});
    }
  };

  const init_tabs = () => {
    let id = items[0].id;
    open_tab(null, id);
  };

  onMount(init_tabs);
</script>


<style>
  button::-moz-focus-inner {
    border: 0;
  }

  .tabs {
    /*overflow: hidden;*/
    /*background-color: #f1f1f1;*/
    /*box-sizing: border-box;*/
    /*margin-left: 1em;*/
    justify-content: center;
    position: relative;
    display: flex;
    flex: 1 0 auto;
    -webkit-transform: none;
    transform: none;
    will-change: transform;
    height: 48px;
  }

  .tab-link {
    font-family: Roboto, sans-serif;
    font-size: .875rem;
    line-height: 2.25rem;
    font-weight: 500;
    letter-spacing: .0892857143em;
    text-transform: uppercase;
    text-align: center;
    white-space: nowrap;
    cursor: pointer;
    /*background-color: #7fafca;*/
    /*float: left;*/
    border: none;
    outline: none;
    /*cursor: pointer;*/
    transition: 0.3s;
    min-width: 140px;
    /*color: #fff;*/
    /*padding: 10px 15px;*/
    /*margin: 0.5em;*/
    /*font-size: 16px;*/
    text-transform: uppercase;
    background: none;
  }

  .tab-link:hover {
    background: #c5dcea;
  }

  .tab-link.active {
    border-bottom-color: #2c3195;
    border-bottom-width: 2px;
    border-bottom-style: solid;
  }

  .tab-content {
    display: flex;
    padding: 6px 10px;
    flex-direction: column;
  }

  .hidden {
    display: none;
  }

  @media screen and (max-width: 1080px) {
  }

  @media screen and (max-width: 800px) {
    .tabs {
      width: 90%;
      height: 65px;
      overflow-x: scroll;
      justify-content: normal;
    }

    .tab-link {
      float: none;
      width: 100%;
      margin-bottom: 1rem;
    }
  }

  @media screen and (max-width: 640px) {
  }

  @media screen and (max-width: 480px) {
  }

  @media screen and (max-width: 360px) {
  }

  @media screen and (max-width: 320px) {
  }
</style>

<div class="tabs">
    {#if items}
        {#each items as item}
          <button class="tab-link"
                  class:active={item.context.active}
                  id={`${item.id}-button`}
                  on:click={(e) => open_tab(e, item.id) }>
              {item.link_label.replace('PilotPoints','')}
          </button>
        {/each}
    {/if}
</div>

{#if items}
    {#each items as item}
      <div id={item.id} class="tab-content hidden">
        <svelte:component this={item.component}
                          id={item.id}
                          main={item.main}
                          context={item.context}
                          on:tabactivated
                          on:ppbuy
                          on:ppdonate
                          on:ppclaim/>
      </div>
    {/each}
{/if}
